import React from "react";

import QueryResults from "components/Common/QueryResults";
import Chart from "components/Common/Chart";
import Loader from "components/Common/Loader";

const EventsChart = ({ results = [] }) => {
  if (!results) {
    return <Loader />;
  }

  const nonNullResults = results.filter(result => {
    return !!result;
  });

  return (
    <Chart
      type="line"
      height={275}
      titleX="Day"
      series={[
        {
          name: "Total Events",
          color: "#9D9DFF",
          fillOpacity: 0.4,
          marker: {
            symbol: "circle",
            fillColor: "#9D9DFF"
          },
          type: "area",
          data: nonNullResults.map(result => ({
            x: Date.parse(result.day),
            y: result.events
          }))
        },
        {
          name: "Unique Users",
          color: "#6FDDDB",
          fillOpacity: 0.4,
          marker: {
            symbol: "circle",
            fillColor: "#6FDDDB"
          },
          type: "area",
          data: nonNullResults.map(result => ({
            x: Date.parse(result.day),
            y: result.users
          }))
        }
      ]}
    />
  );
};

const EventsChartWithAnalytics = ({ startTime }) => {
  return (
    <QueryResults
      query={{
        conditions: [
          ["event", "not like", "appcues:%"],
          ["event", "not like", "appcues_custom:%"]
        ],
        metrics: ["events", "users"],
        dimensions: ["day"],
        start_time: startTime
      }}
    >
      {results => {
        return <EventsChart results={results} />;
      }}
    </QueryResults>
  );
};

export default EventsChartWithAnalytics;
